export default "__VITE_ASSET__DAhHXrob__"